import { useLocation, useNavigate } from "react-router";
import { Alert } from "../../../../components/alert/Alert";
import { Dashboard } from "../../../../components/dashboard/Dashboard";
import { SpinnerLegacy } from "../../../../components";
import { NEW_PRODUCT, PRODUCT_LIST } from "../../../../constants/routes";
import { useSupplierProductExistence } from "../../../../hooks/api/v2/product/useSupplierProductExistence";
import { NavigationBarMenu } from "../../../../components/navigation/NavigationBar";
import { useFeatureFlagStore } from "../../../../hooks/useFeatureFlags";
import { ProductContainerTemplateSetup } from "./ProductContainerTemplateSetup";
import { ProductListV2Tabs } from "./ProductListV2Tabs";

export const ProductListRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const productContainerOnboardingEnabled = useFeatureFlagStore((store) =>
    store.isActive("PRODUCT_CONTAINER_ONBOARDING"),
  );
  const productExistenceQuery = useSupplierProductExistence(
    productContainerOnboardingEnabled,
  );

  const isBaseProductListRoute =
    location.pathname === PRODUCT_LIST ||
    location.pathname === `${PRODUCT_LIST}/`;
  const hasProducts = Boolean(productExistenceQuery.data?.pages[0]?.length);

  if (!productContainerOnboardingEnabled) {
    return <ProductListDashboard />;
  }

  if (
    (isBaseProductListRoute || location.pathname === NEW_PRODUCT) &&
    productExistenceQuery.isPending
  ) {
    return <SpinnerLegacy />;
  }

  if (
    (isBaseProductListRoute || location.pathname === NEW_PRODUCT) &&
    productExistenceQuery.isError
  ) {
    return (
      <div className="p-4">
        <Alert
          type="error"
          title="Unable to load your products"
          message="Refresh the page to try again."
        />
      </div>
    );
  }

  if (isBaseProductListRoute && !hasProducts) {
    return (
      <>
        <NavigationBarMenu title="Product List" />
        <ProductContainerTemplateSetup
          onCreateProduct={() => navigate(NEW_PRODUCT)}
        />
      </>
    );
  }

  return (
    <ProductListDashboard
      hideList={!hasProducts && location.pathname === NEW_PRODUCT}
    />
  );
};

const ProductListDashboard = ({ hideList = false }: { hideList?: boolean }) => (
  <Dashboard
    width={hideList ? Infinity : 1024}
    parentComponent={<ProductListV2Tabs />}
    parentPart="minmax(400px,30%)"
    childPart="1fr"
  />
);
